import React, { useState } from 'react'
import { format } from '../../utils/number'
import { getDateTime } from '../../utils/date'
import { useLoad } from '../../hooks/request'

export const SalesHistoryComponent = () => {
    const [filters, setFilters] = useState({
        start_date: '',
        end_date: '',
        product_id: '',
        supplier_id: '',
        batch_id: '',
        search: ''
    })

    // Using your custom useLoad hook for data fetching
    const salesHistoryData = useLoad({
        url: '/main/api/sales-history/',
        params: filters
    }, [filters])

    const summaryData = useLoad({
        url: '/main/api/sales-history/summary/'
    })

    const productBatches = useLoad({
        url: '/main/api/product-batches/'
    })

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }))
    }

    const clearFilters = () => {
        setFilters({
            start_date: '',
            end_date: '',
            product_id: '',
            supplier_id: '',
            batch_id: '',
            search: ''
        })
    }

    // Helper function to avoid nested ternary
    const renderTableBody = () => {
        if (salesHistoryData.loading) {
            return (
                <tr>
                    <td colSpan="9" style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>
                        Загрузка...
                    </td>
                </tr>
            )
        }

        if (!salesHistoryData.response?.results || salesHistoryData.response.results.length === 0) {
            return (
                <tr>
                    <td colSpan="9" style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>
                        Нет данных для отображения
                    </td>
                </tr>
            )
        }

        return salesHistoryData.response.results.map((sale, index) => (
            <tr key={sale.id || index} style={{
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                borderBottom: '1px solid #dee2e6'
            }}>
                <td style={{ padding: '12px' }}>
                    {sale.created_at ? getDateTime(new Date(sale.created_at)) : 'Н/Д'}
                </td>
                <td style={{ padding: '12px', fontWeight: 'bold' }}>
                    {sale.product_name || 'Н/Д'}
                </td>
                <td style={{ padding: '12px' }}>
                    {sale.batch_number || 'Н/Д'}
                </td>
                <td style={{ padding: '12px' }}>
                    {sale.supplier_name || 'Н/Д'}
                </td>
                <td style={{ padding: '12px' }}>
                    {sale.client_name || 'Н/Д'}
                </td>
                <td style={{ padding: '12px', textAlign: 'right' }}>
                    {sale.quantity_sold ? format(sale.quantity_sold) : '0'}
                </td>
                <td style={{ padding: '12px', textAlign: 'right' }}>
                    {sale.purchase_price ? format(sale.purchase_price) : '0'} Сум
                </td>
                <td style={{ padding: '12px', textAlign: 'right' }}>
                    {sale.sale_price ? format(sale.sale_price) : '0'} Сум
                </td>
                <td style={{
                    padding: '12px',
                    textAlign: 'right',
                    color: (sale.profit || 0) > 0 ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}>
                    {sale.profit ? format(sale.profit) : '0'} Сум
                    {sale.profit_percentage && (
                        <div style={{ fontSize: '12px', color: '#6c757d' }}>
                            ({sale.profit_percentage}%)
                        </div>
                    )}
                </td>
            </tr>
        ))
    }

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1 style={{ marginBottom: '20px', color: '#333' }}>
                История продаж по партиям
            </h1>

            {/* Show error if exists */}
            {salesHistoryData.error?.data && (
                <div style={{
                    padding: '15px',
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    border: '1px solid #f5c6cb',
                    borderRadius: '8px',
                    marginBottom: '20px'
                }}>
                    Ошибка: {salesHistoryData.error.data.detail || 'Произошла ошибка при загрузке данных'}
                </div>
            )}

            {/* Summary Stats */}
            {summaryData.response && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px',
                    marginBottom: '30px'
                }}>
                    <div style={{
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                    }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#495057' }}>Общее количество</h3>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#28a745' }}>
                            {format(summaryData.response.summary?.total_quantity || 0)}
                        </p>
                    </div>
                    <div style={{
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                    }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#495057' }}>Общий доход</h3>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
                            {format(summaryData.response.summary?.total_revenue || 0)} Сум
                        </p>
                    </div>
                    <div style={{
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                    }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#495057' }}>Общая прибыль</h3>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#28a745' }}>
                            {format(summaryData.response.summary?.total_profit || 0)} Сум
                        </p>
                    </div>
                </div>
            )}

            {/* Filters */}
            <div style={{
                backgroundColor: '#f8f9fa',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #dee2e6'
            }}>
                <h3 style={{ marginBottom: '15px', color: '#495057' }}>Фильтры</h3>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px'
                }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Начальная дата:
                        </label>
                        <input
                            type="date"
                            value={filters.start_date}
                            onChange={(e) => handleFilterChange('start_date', e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Конечная дата:
                        </label>
                        <input
                            type="date"
                            value={filters.end_date}
                            onChange={(e) => handleFilterChange('end_date', e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Партия:
                        </label>
                        <select
                            value={filters.batch_id}
                            onChange={(e) => handleFilterChange('batch_id', e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px'
                            }}
                        >
                            <option value="">Все партии</option>
                            {productBatches.response?.results?.map((batch) => (
                                <option key={batch.id} value={batch.id}>
                                    {batch.batch_number} - {batch.nomenclature_name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Поиск:
                        </label>
                        <input
                            type="text"
                            placeholder="Поиск по товару, партии, клиенту..."
                            value={filters.search}
                            onChange={(e) => handleFilterChange('search', e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                </div>
                <button
                    onClick={clearFilters}
                    style={{
                        marginTop: '15px',
                        padding: '8px 16px',
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Очистить фильтры
                </button>
            </div>

            {/* Sales History Table */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid #dee2e6'
            }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ backgroundColor: '#495057', color: 'white' }}>
                        <tr>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>
                                Дата
                            </th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>
                                Товар
                            </th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>
                                Партия
                            </th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>
                                Поставщик
                            </th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>
                                Клиент
                            </th>
                            <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>
                                Количество
                            </th>
                            <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>
                                Цена покупки
                            </th>
                            <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>
                                Цена продажи
                            </th>
                            <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>
                                Прибыль
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderTableBody()}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
